import scrollAnimate from '../components/scrollAnimate';

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
export function clearFormErrors(form) {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
}

export default function formValidation(formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $('.alert', formElement).remove();
    var isFormElementAForm = formElement && formElement[0] && formElement[0] instanceof HTMLFormElement;

    if (typeof payload === 'object' && payload.fields) {
        Object.keys(payload.fields).forEach((key) => {
            if (payload.fields[key]) {
                const feedbackElement = $(formElement).find(`[name="${key}"]`)
                    .parent()
                    .children('.invalid-feedback');

                if (feedbackElement.length > 0) {
                    if (Array.isArray(payload.fields[key])) {
                        feedbackElement.html(payload.fields[key].join('<br/>'));
                    } else {
                        feedbackElement.html(payload.fields[key]);
                    }
                    feedbackElement.siblings('.form-control').addClass('is-invalid');
                }
                if (isFormElementAForm) {
                    const firstInvalid = $(formElement).find('.is-invalid').first();
                    if (firstInvalid && firstInvalid.attr('name') === key) {
                        scrollAnimate(firstInvalid, 100 /* offset */);
                    }
                }
            }
        });
    }
    if (payload && payload.error) {
        const $form = isFormElementAForm ? $(formElement[0]) : $(formElement).parents('form');

        $form.prepend(`<div class="js-backend-validation-fail alert alert-danger" role="alert"><p class="text-red mb-0">${
            payload.error.join('<br/>')}</p></div>`);
            scrollAnimate($('.js-backend-validation-fail'), 100 /* offset */);
    }
}
